// extracted by mini-css-extract-plugin
export default {"examples":"Examples_examples__QEDul","example":"Examples_example__kWbqs","title":"Examples_title__JHVbw","image":"Examples_image__UILVX"};